import * as Types from '../../types/bff/gql-schema';

import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const GetSearchResultFeedbackCategoriesDocument = `
    query getSearchResultFeedbackCategories {
  searchResultFeedbackCategories {
    id
    name
    isNeedToUserDirectInput
  }
}
    `;
export const useGetSearchResultFeedbackCategoriesQuery = <
      TData = Types.GetSearchResultFeedbackCategoriesQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.GetSearchResultFeedbackCategoriesQueryVariables,
      options?: UseQueryOptions<Types.GetSearchResultFeedbackCategoriesQuery, TError, TData>,
    ) =>
    useQuery<Types.GetSearchResultFeedbackCategoriesQuery, TError, TData>(
      variables === undefined ? ['getSearchResultFeedbackCategories'] : ['getSearchResultFeedbackCategories', variables],
      gqlFetcher<Types.GetSearchResultFeedbackCategoriesQuery, Types.GetSearchResultFeedbackCategoriesQueryVariables>(GetSearchResultFeedbackCategoriesDocument, 'getSearchResultFeedbackCategories', variables),
      options
    );

useGetSearchResultFeedbackCategoriesQuery.getKey = (variables?: Types.GetSearchResultFeedbackCategoriesQueryVariables) => variables === undefined ? ['getSearchResultFeedbackCategories'] : ['getSearchResultFeedbackCategories', variables];
;

useGetSearchResultFeedbackCategoriesQuery.fetcher = (variables?: Types.GetSearchResultFeedbackCategoriesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetSearchResultFeedbackCategoriesQuery, Types.GetSearchResultFeedbackCategoriesQueryVariables>(GetSearchResultFeedbackCategoriesDocument, 'getSearchResultFeedbackCategories', variables, options);
export const GetSearchResultFeedbackSubCategoriesByCategoryIdDocument = `
    query getSearchResultFeedbackSubCategoriesByCategoryId($categoryId: ID!) {
  searchResultFeedbackSubCategoriesByCategoryId(categoryId: $categoryId) {
    id
    name
    isNeedToUserDirectInput
  }
}
    `;
export const useGetSearchResultFeedbackSubCategoriesByCategoryIdQuery = <
      TData = Types.GetSearchResultFeedbackSubCategoriesByCategoryIdQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetSearchResultFeedbackSubCategoriesByCategoryIdQueryVariables,
      options?: UseQueryOptions<Types.GetSearchResultFeedbackSubCategoriesByCategoryIdQuery, TError, TData>,
    ) =>
    useQuery<Types.GetSearchResultFeedbackSubCategoriesByCategoryIdQuery, TError, TData>(
      ['getSearchResultFeedbackSubCategoriesByCategoryId', variables],
      gqlFetcher<Types.GetSearchResultFeedbackSubCategoriesByCategoryIdQuery, Types.GetSearchResultFeedbackSubCategoriesByCategoryIdQueryVariables>(GetSearchResultFeedbackSubCategoriesByCategoryIdDocument, 'getSearchResultFeedbackSubCategoriesByCategoryId', variables),
      options
    );

useGetSearchResultFeedbackSubCategoriesByCategoryIdQuery.getKey = (variables: Types.GetSearchResultFeedbackSubCategoriesByCategoryIdQueryVariables) => ['getSearchResultFeedbackSubCategoriesByCategoryId', variables];
;

useGetSearchResultFeedbackSubCategoriesByCategoryIdQuery.fetcher = (variables: Types.GetSearchResultFeedbackSubCategoriesByCategoryIdQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetSearchResultFeedbackSubCategoriesByCategoryIdQuery, Types.GetSearchResultFeedbackSubCategoriesByCategoryIdQueryVariables>(GetSearchResultFeedbackSubCategoriesByCategoryIdDocument, 'getSearchResultFeedbackSubCategoriesByCategoryId', variables, options);
export const SubmitSearchResultFeedbackDocument = `
    mutation submitSearchResultFeedback($request: SearchResultFeedbackSubmitRequestInput!) {
  submitSearchResultFeedback(request: $request)
}
    `;
export const useSubmitSearchResultFeedbackMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.SubmitSearchResultFeedbackMutation, TError, Types.SubmitSearchResultFeedbackMutationVariables, TContext>) =>
    useMutation<Types.SubmitSearchResultFeedbackMutation, TError, Types.SubmitSearchResultFeedbackMutationVariables, TContext>(
      ['submitSearchResultFeedback'],
      (variables?: Types.SubmitSearchResultFeedbackMutationVariables) => gqlFetcher<Types.SubmitSearchResultFeedbackMutation, Types.SubmitSearchResultFeedbackMutationVariables>(SubmitSearchResultFeedbackDocument, 'submitSearchResultFeedback', variables)(),
      options
    );
useSubmitSearchResultFeedbackMutation.fetcher = (variables: Types.SubmitSearchResultFeedbackMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SubmitSearchResultFeedbackMutation, Types.SubmitSearchResultFeedbackMutationVariables>(SubmitSearchResultFeedbackDocument, 'submitSearchResultFeedback', variables, options);
export const GetPopularKeywordsDocument = `
    query GetPopularKeywords {
  getPopularSymptoms {
    name
    publicId
  }
}
    `;
export const useGetPopularKeywordsQuery = <
      TData = Types.GetPopularKeywordsQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.GetPopularKeywordsQueryVariables,
      options?: UseQueryOptions<Types.GetPopularKeywordsQuery, TError, TData>,
    ) =>
    useQuery<Types.GetPopularKeywordsQuery, TError, TData>(
      variables === undefined ? ['GetPopularKeywords'] : ['GetPopularKeywords', variables],
      gqlFetcher<Types.GetPopularKeywordsQuery, Types.GetPopularKeywordsQueryVariables>(GetPopularKeywordsDocument, 'GetPopularKeywords', variables),
      options
    );

useGetPopularKeywordsQuery.getKey = (variables?: Types.GetPopularKeywordsQueryVariables) => variables === undefined ? ['GetPopularKeywords'] : ['GetPopularKeywords', variables];
;

useGetPopularKeywordsQuery.fetcher = (variables?: Types.GetPopularKeywordsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetPopularKeywordsQuery, Types.GetPopularKeywordsQueryVariables>(GetPopularKeywordsDocument, 'GetPopularKeywords', variables, options);
export const GetkeywordSearchQnaDocument = `
    query getkeywordSearchQna($request: KeywordSearchQuestionCardCursorPageRequestInput!) {
  keywordSearchQuestionCardCursorPage(request: $request) {
    elements {
      question {
        status
        questionPid
        title
        content
        category {
          questionCategoryId
          name
          type
          iconImageUrl
          aiAnswerAvailable
        }
        user {
          userId
          name
          gender
          birth
        }
        createdAt
        viewCount
        likeCount
        isLikedByMe
        isMine
        tags {
          questionTagId
          name
        }
        attachments {
          questionAttachmentId
          blindType
        }
        isBlockedByMe
        accessibleType
        aiAnswerStatus
      }
      answererCount
      answeredStatus
      answererProfileImageUrls
    }
  }
}
    `;
export const useGetkeywordSearchQnaQuery = <
      TData = Types.GetkeywordSearchQnaQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetkeywordSearchQnaQueryVariables,
      options?: UseQueryOptions<Types.GetkeywordSearchQnaQuery, TError, TData>,
    ) =>
    useQuery<Types.GetkeywordSearchQnaQuery, TError, TData>(
      ['getkeywordSearchQna', variables],
      gqlFetcher<Types.GetkeywordSearchQnaQuery, Types.GetkeywordSearchQnaQueryVariables>(GetkeywordSearchQnaDocument, 'getkeywordSearchQna', variables),
      options
    );

useGetkeywordSearchQnaQuery.getKey = (variables: Types.GetkeywordSearchQnaQueryVariables) => ['getkeywordSearchQna', variables];
;

useGetkeywordSearchQnaQuery.fetcher = (variables: Types.GetkeywordSearchQnaQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetkeywordSearchQnaQuery, Types.GetkeywordSearchQnaQueryVariables>(GetkeywordSearchQnaDocument, 'getkeywordSearchQna', variables, options);
export const GetKeywordSearchMagazineDocument = `
    query getKeywordSearchMagazine($request: KeywordSearchMagazineCursorPageRequestInput!) {
  keywordSearchMagazineCursorPage(request: $request) {
    elements {
      magazineId
      magazinePid
      title
      mobileTitle
      titleImageUrl
      description
      mobileDescription
      content
      mobileContent
      footnote
      tagNames
      likeCount
      author {
        authorType
        authorId
        name
        profileImageUrl
        affiliatedInstitutionName
        professionalFields {
          professionalFieldId
          professionalFieldType
          name
        }
        externalLinkUrl
      }
      questionCategoryId
      bottomButtonType
      isLikedByMe
      createdAt
    }
  }
}
    `;
export const useGetKeywordSearchMagazineQuery = <
      TData = Types.GetKeywordSearchMagazineQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetKeywordSearchMagazineQueryVariables,
      options?: UseQueryOptions<Types.GetKeywordSearchMagazineQuery, TError, TData>,
    ) =>
    useQuery<Types.GetKeywordSearchMagazineQuery, TError, TData>(
      ['getKeywordSearchMagazine', variables],
      gqlFetcher<Types.GetKeywordSearchMagazineQuery, Types.GetKeywordSearchMagazineQueryVariables>(GetKeywordSearchMagazineDocument, 'getKeywordSearchMagazine', variables),
      options
    );

useGetKeywordSearchMagazineQuery.getKey = (variables: Types.GetKeywordSearchMagazineQueryVariables) => ['getKeywordSearchMagazine', variables];
;

useGetKeywordSearchMagazineQuery.fetcher = (variables: Types.GetKeywordSearchMagazineQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetKeywordSearchMagazineQuery, Types.GetKeywordSearchMagazineQueryVariables>(GetKeywordSearchMagazineDocument, 'getKeywordSearchMagazine', variables, options);
export const GetDoctorsByKeywordDocument = `
    query getDoctorsByKeyword($request: NonFaceToFaceDoctorCursorPageRequestInput!) {
  getDoctorsByKeyword(request: $request) {
    elements {
      id
      doctorName
      hospitalName
      profileUrl
      publicId
      reviewAverageRating
      readyForVideoCall
      reviewCount
      isAbsent
      isBookable
      maxWaitingCount
      medicineType
      diagnosisCount {
        doctorId
        count
      }
      professionalDepartment {
        doctorId
        professionalDepartmentName
        professionalDepartmentId
      }
    }
    pivot
  }
}
    `;
export const useGetDoctorsByKeywordQuery = <
      TData = Types.GetDoctorsByKeywordQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetDoctorsByKeywordQueryVariables,
      options?: UseQueryOptions<Types.GetDoctorsByKeywordQuery, TError, TData>,
    ) =>
    useQuery<Types.GetDoctorsByKeywordQuery, TError, TData>(
      ['getDoctorsByKeyword', variables],
      gqlFetcher<Types.GetDoctorsByKeywordQuery, Types.GetDoctorsByKeywordQueryVariables>(GetDoctorsByKeywordDocument, 'getDoctorsByKeyword', variables),
      options
    );

useGetDoctorsByKeywordQuery.getKey = (variables: Types.GetDoctorsByKeywordQueryVariables) => ['getDoctorsByKeyword', variables];
;

useGetDoctorsByKeywordQuery.fetcher = (variables: Types.GetDoctorsByKeywordQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetDoctorsByKeywordQuery, Types.GetDoctorsByKeywordQueryVariables>(GetDoctorsByKeywordDocument, 'getDoctorsByKeyword', variables, options);
export const GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageDocument = `
    query getDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage($request: DiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageRequestInput!) {
  diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage(request: $request) {
    elements {
      hospitalAddress
      hospitalBadges
      hospitalDistance
      hospitalId
      hospitalName
      hospitalOperationStatus
      hospitalPublicId
      hospitalRepresentativeImageUrl
      hospitalRepresentativeDepartmentName
      isBookable
      reviewAverageRating
      reviewTotalCount
      doctors {
        contractType
      }
    }
    pivot
    pivotScore
    totalCount
  }
}
    `;
export const useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery = <
      TData = Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQueryVariables,
      options?: UseQueryOptions<Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery, TError, TData>,
    ) =>
    useQuery<Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery, TError, TData>(
      ['getDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage', variables],
      gqlFetcher<Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery, Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQueryVariables>(GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageDocument, 'getDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage', variables),
      options
    );

useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery.getKey = (variables: Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQueryVariables) => ['getDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage', variables];
;

useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery.fetcher = (variables: Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery, Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQueryVariables>(GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageDocument, 'getDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage', variables, options);
export const SearchNonF2fDoctorsDocument = `
    query SearchNonF2fDoctors($request: NonF2fDoctorSearchRequestInput!) {
  searchNonF2fDoctors(request: $request) {
    medicalCategoryGraph {
      category
      id
    }
    items {
      createdAt
      distance
      departments {
        id
        description
        isProfessional
        name
      }
      id
      publicId
      isAffiliated
      isNew
      maxWaitingCount
      medicineType
      name
      nonBenefitMedicinePricing {
        doctorId
        doctorTreatmentMedicineUnitPricingId
        originalPrice
        priceOnUsingPoint
        treatmentMedicineName
        unitDisplayName
        unitTypeDisplayName
        usablePoint
      }
      profileUrl
      professionalDepartment {
        description
        id
        isProfessional
        name
      }
      readyForVideoCall
      reviewAverageRating
      reviewCount
      diagnosisCount {
        count
        doctorId
      }
      hospitalV2 {
        doctorHospitalId
        doctorId
        hospitalName
      }
      bookingInfo {
        bookingAvailability
        isBookable
        todayBookable
        todayCutoffTime
        todayKickoffTime
        todaySchedule
        tomorrowBookable
        tomorrowCutoffTime
        tomorrowKickoffTime
        tomorrowSchedule
      }
    }
  }
}
    `;
export const useSearchNonF2fDoctorsQuery = <
      TData = Types.SearchNonF2fDoctorsQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchNonF2fDoctorsQueryVariables,
      options?: UseQueryOptions<Types.SearchNonF2fDoctorsQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchNonF2fDoctorsQuery, TError, TData>(
      ['SearchNonF2fDoctors', variables],
      gqlFetcher<Types.SearchNonF2fDoctorsQuery, Types.SearchNonF2fDoctorsQueryVariables>(SearchNonF2fDoctorsDocument, 'SearchNonF2fDoctors', variables),
      options
    );

useSearchNonF2fDoctorsQuery.getKey = (variables: Types.SearchNonF2fDoctorsQueryVariables) => ['SearchNonF2fDoctors', variables];
;

useSearchNonF2fDoctorsQuery.fetcher = (variables: Types.SearchNonF2fDoctorsQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchNonF2fDoctorsQuery, Types.SearchNonF2fDoctorsQueryVariables>(SearchNonF2fDoctorsDocument, 'SearchNonF2fDoctors', variables, options);
export const GeneralSearchMetaByKeywordDocument = `
    query GeneralSearchMetaByKeyword($keyword: String!) {
  generalSearchMetaByKeyword(keyword: $keyword) {
    features
    snippet
  }
}
    `;
export const useGeneralSearchMetaByKeywordQuery = <
      TData = Types.GeneralSearchMetaByKeywordQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GeneralSearchMetaByKeywordQueryVariables,
      options?: UseQueryOptions<Types.GeneralSearchMetaByKeywordQuery, TError, TData>,
    ) =>
    useQuery<Types.GeneralSearchMetaByKeywordQuery, TError, TData>(
      ['GeneralSearchMetaByKeyword', variables],
      gqlFetcher<Types.GeneralSearchMetaByKeywordQuery, Types.GeneralSearchMetaByKeywordQueryVariables>(GeneralSearchMetaByKeywordDocument, 'GeneralSearchMetaByKeyword', variables),
      options
    );

useGeneralSearchMetaByKeywordQuery.getKey = (variables: Types.GeneralSearchMetaByKeywordQueryVariables) => ['GeneralSearchMetaByKeyword', variables];
;

useGeneralSearchMetaByKeywordQuery.fetcher = (variables: Types.GeneralSearchMetaByKeywordQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GeneralSearchMetaByKeywordQuery, Types.GeneralSearchMetaByKeywordQueryVariables>(GeneralSearchMetaByKeywordDocument, 'GeneralSearchMetaByKeyword', variables, options);
export const GetSearchMedicineDictionaryByCursorScorePageDocument = `
    query GetSearchMedicineDictionaryByCursorScorePage($request: MedicineDictionarySearchByCursorRequestInput!) {
  searchMedicineDictionaryByCursorScorePage(request: $request) {
    totalCount
    pivotScore
    pivotId
    items {
      id
      publicId
      basicInfo {
        name
        simplifiedName
        pharmaceuticalEffectLiteracy
        medicineImage
      }
      medicineGuide {
        wholeSummary
      }
      packagingInfo {
        image
      }
    }
  }
}
    `;
export const useGetSearchMedicineDictionaryByCursorScorePageQuery = <
      TData = Types.GetSearchMedicineDictionaryByCursorScorePageQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetSearchMedicineDictionaryByCursorScorePageQueryVariables,
      options?: UseQueryOptions<Types.GetSearchMedicineDictionaryByCursorScorePageQuery, TError, TData>,
    ) =>
    useQuery<Types.GetSearchMedicineDictionaryByCursorScorePageQuery, TError, TData>(
      ['GetSearchMedicineDictionaryByCursorScorePage', variables],
      gqlFetcher<Types.GetSearchMedicineDictionaryByCursorScorePageQuery, Types.GetSearchMedicineDictionaryByCursorScorePageQueryVariables>(GetSearchMedicineDictionaryByCursorScorePageDocument, 'GetSearchMedicineDictionaryByCursorScorePage', variables),
      options
    );

useGetSearchMedicineDictionaryByCursorScorePageQuery.getKey = (variables: Types.GetSearchMedicineDictionaryByCursorScorePageQueryVariables) => ['GetSearchMedicineDictionaryByCursorScorePage', variables];
;

useGetSearchMedicineDictionaryByCursorScorePageQuery.fetcher = (variables: Types.GetSearchMedicineDictionaryByCursorScorePageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetSearchMedicineDictionaryByCursorScorePageQuery, Types.GetSearchMedicineDictionaryByCursorScorePageQueryVariables>(GetSearchMedicineDictionaryByCursorScorePageDocument, 'GetSearchMedicineDictionaryByCursorScorePage', variables, options);
export const SearchMedicineDictionaryDocument = `
    query SearchMedicineDictionary($request: MedicineDictionarySearchRequestInput!) {
  searchMedicineDictionary(request: $request) {
    totalCount
    totalPage
    items {
      id
      publicId
      basicInfo {
        name
        pharmaceuticalEffectLiteracy
        medicineImage
        simplifiedName
      }
      medicineGuide {
        wholeSummary
      }
      packagingInfo {
        image
      }
    }
  }
}
    `;
export const useSearchMedicineDictionaryQuery = <
      TData = Types.SearchMedicineDictionaryQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchMedicineDictionaryQueryVariables,
      options?: UseQueryOptions<Types.SearchMedicineDictionaryQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchMedicineDictionaryQuery, TError, TData>(
      ['SearchMedicineDictionary', variables],
      gqlFetcher<Types.SearchMedicineDictionaryQuery, Types.SearchMedicineDictionaryQueryVariables>(SearchMedicineDictionaryDocument, 'SearchMedicineDictionary', variables),
      options
    );

useSearchMedicineDictionaryQuery.getKey = (variables: Types.SearchMedicineDictionaryQueryVariables) => ['SearchMedicineDictionary', variables];
;

useSearchMedicineDictionaryQuery.fetcher = (variables: Types.SearchMedicineDictionaryQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchMedicineDictionaryQuery, Types.SearchMedicineDictionaryQueryVariables>(SearchMedicineDictionaryDocument, 'SearchMedicineDictionary', variables, options);
export const SearchDiseaseEncyclopediaDocument = `
    query SearchDiseaseEncyclopedia($request: DiseaseEncyclopediaSearchRequestInput!) {
  searchDiseaseEncyclopedia(request: $request) {
    totalCount
    totalPageCount
    items {
      content
      title
      titleImageUrl
      publicId
    }
  }
}
    `;
export const useSearchDiseaseEncyclopediaQuery = <
      TData = Types.SearchDiseaseEncyclopediaQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchDiseaseEncyclopediaQueryVariables,
      options?: UseQueryOptions<Types.SearchDiseaseEncyclopediaQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchDiseaseEncyclopediaQuery, TError, TData>(
      ['SearchDiseaseEncyclopedia', variables],
      gqlFetcher<Types.SearchDiseaseEncyclopediaQuery, Types.SearchDiseaseEncyclopediaQueryVariables>(SearchDiseaseEncyclopediaDocument, 'SearchDiseaseEncyclopedia', variables),
      options
    );

useSearchDiseaseEncyclopediaQuery.getKey = (variables: Types.SearchDiseaseEncyclopediaQueryVariables) => ['SearchDiseaseEncyclopedia', variables];
;

useSearchDiseaseEncyclopediaQuery.fetcher = (variables: Types.SearchDiseaseEncyclopediaQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchDiseaseEncyclopediaQuery, Types.SearchDiseaseEncyclopediaQueryVariables>(SearchDiseaseEncyclopediaDocument, 'SearchDiseaseEncyclopedia', variables, options);
export const SearchDiseaseEncyclopediaByCursorScorePageDocument = `
    query SearchDiseaseEncyclopediaByCursorScorePage($request: DiseaseEncyclopediaSearchByCursorRequestInput!) {
  searchDiseaseEncyclopediaByCursorScorePage(request: $request) {
    pivotId
    pivotScore
    totalCount
    items {
      content
      title
      titleImageUrl
      publicId
    }
  }
}
    `;
export const useSearchDiseaseEncyclopediaByCursorScorePageQuery = <
      TData = Types.SearchDiseaseEncyclopediaByCursorScorePageQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchDiseaseEncyclopediaByCursorScorePageQueryVariables,
      options?: UseQueryOptions<Types.SearchDiseaseEncyclopediaByCursorScorePageQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchDiseaseEncyclopediaByCursorScorePageQuery, TError, TData>(
      ['SearchDiseaseEncyclopediaByCursorScorePage', variables],
      gqlFetcher<Types.SearchDiseaseEncyclopediaByCursorScorePageQuery, Types.SearchDiseaseEncyclopediaByCursorScorePageQueryVariables>(SearchDiseaseEncyclopediaByCursorScorePageDocument, 'SearchDiseaseEncyclopediaByCursorScorePage', variables),
      options
    );

useSearchDiseaseEncyclopediaByCursorScorePageQuery.getKey = (variables: Types.SearchDiseaseEncyclopediaByCursorScorePageQueryVariables) => ['SearchDiseaseEncyclopediaByCursorScorePage', variables];
;

useSearchDiseaseEncyclopediaByCursorScorePageQuery.fetcher = (variables: Types.SearchDiseaseEncyclopediaByCursorScorePageQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchDiseaseEncyclopediaByCursorScorePageQuery, Types.SearchDiseaseEncyclopediaByCursorScorePageQueryVariables>(SearchDiseaseEncyclopediaByCursorScorePageDocument, 'SearchDiseaseEncyclopediaByCursorScorePage', variables, options);